<div class="modal-header" ngbAutofocus>
    <h3>Thanks for submitting!</h3>
</div>
<div class="modal-body">
    <div class="alert" *ngIf="alert != null" [ngClass]="{'alert-success' : alert.type == 'success', 'alert-default' : alert.type == 'default', 'alert-danger': alert.type == 'danger' }" role="alert">
        {{alert.msg}}
    </div>
    <img *ngIf="jobTargetTrackingURL != null" [src]="jobTargetTrackingURL" height="1" width="1" style="display:none" />
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="closeClicked()">Return<span *ngIf="!info.IsOnboarding"> to Careers Page</span></button>
    <button type="button" class="btn btn-outline-dark" (click)="returnClicked()" *ngIf="loginStatus && reqID != null">Return<span *ngIf="!info.IsOnboarding"> to Job Req. Detail</span></button>
</div>